angular.module('leanlaw').controller('ClientActivityCtrl', ['$scope', '$stateParams', '$q', 'singleRequest', 'alerts', function ($scope, $stateParams, $q, singleRequest, alerts) {
  $scope.transactions = [];
  activate();
  function activate() {
    const query = {
      clientId: $stateParams.id
    };
    const load = [];
    load.push(singleRequest.apiCall("time").listInvoices(query).then(({
      invoices
    }) => {
      if (!invoices) return;
      invoices.forEach(invoice => {
        $scope.transactions.push({
          date: invoice.invoiceDate,
          referenceLabel: invoice.reference,
          invoices: [invoice],
          amount: invoice.totals.amount,
          matter: invoice.matter || {
            label: '-'
          },
          description: 'Invoice',
          invoice
        });
      });
    }));
    load.push(singleRequest.apiCall("expenses").listPayments(query).then(({
      payments
    }) => {
      if (!payments) return;
      payments.forEach(payment => {
        $scope.transactions.push({
          date: payment.date,
          amount: payment.amount,
          matter: payment.matter || {
            label: '-'
          },
          description: 'Payment',
          referenceLabel: payment.invoices.map(i => i.invoice.reference).join(', '),
          invoices: payment.invoices.map(i => i.invoice)
        });
      });
    }));

    // TODO load trust

    $scope.loading = true;
    $q.all(load).catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.loading = false;
    });
  }
}]);